import commonMapping from "@/mapping/common";

export const webManage = {
  force_https: commonMapping.intToBoolean,
};

export default webManage;
